export default __webpack_public_path__ + "static/media/include_0_female@2x.42e395d4.jpg";